<header class="admin-header">
  <div class="admin-header__breadcrumb">
    <span class="admin-header__root">Backoffice</span>
    @for (crumb of breadcrumbs; track crumb; let last = $last) {
      <span class="admin-header__sep" aria-hidden="true">/</span>
      <span [class.admin-header__current]="last">{{ crumb }}</span>
    }
  </div>
  <h2 class="admin-header__title">{{ pageTitle }}</h2>
</header>
